import gsap from "gsap/gsap-core";
import _ from 'lodash'

let breakpoints = []; 

function onIntersection(entries){
    entries.forEach(
        entry => {
            const target = entry.target;
            const classList = target?.classList;
            if(entry.isIntersecting && !classList?.contains('large')){
                gsap.to(target,{
                    scale:1,
                    duration: 0.3,
                    onComplete: function(){
                        classList.add('large');
                    }
                })
            }else{
                gsap.to(target,{
                    scale:0.85,
                    duration: 0.3,
                    onComplete: function(){
                        classList.remove('large');
                    }
                })
            }
        }
    )
}


export const setBreakPoints = function(){
    breakpoints = Array.from(document.querySelectorAll('.full-width'));
    let intersectionObserverOptions = {
        root: null,  
        threshold: .50 
      }
          
    let observer = new IntersectionObserver(onIntersection, intersectionObserverOptions)

    breakpoints.forEach(
        breakpoint => {
            observer.observe(breakpoint);
        }
    )

}